import * as yup from "yup";

export const fundingFormSchema = yup.object({
  businessName: yup.string().required("Business Name is required"),
  website: yup
    .string()
    .matches(
      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/,
      "Enter a valid URL"
    )
    .optional(),
  businessEmail: yup
    .string()
    .email("Enter a valid email")
    .required("Business email is required"),
  uploadedFiles: yup
    .array()
    .of(
      yup.object().shape({
        Bucket: yup.string().required(),
        S3Key: yup.string().required(),
        type: yup.string().required(),
        name: yup.string().optional(),
      })
    )
    .optional(),
  projectDescription: yup.string().required("Project description is required"),
  country: yup.string().required("Country is required"),
  state: yup.string().required("State is required"),
  currency: yup.string().required("Currency is required"),
  amount: yup.string().required("Amount is required"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  role: yup.string().required("Role is required"),
  phone: yup.string().required("Phone number is required"),
  countryCode: yup.string().optional(),
});

export const step1Schema = yup.object({
  businessName: yup.string().required("Business Name is required"),
  website: yup
    .string()
    .matches(
      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/,
      "Enter a valid URL"
    )
    .optional(),
  businessEmail: yup
    .string()
    .email("Enter a valid email")
    .required("Business email is required"),
});

export const step2Schema = yup.object({
  uploadedFiles: yup
    .array()
    .of(
      yup.object().shape({
        Bucket: yup.string().required(),
        S3Key: yup.string().required(),
        type: yup.string().required(),
        name: yup.string().optional(),
      })
    )
    .optional(),
  projectDescription: yup.string().required("Project description is required"),
  country: yup.string().required("Country is required"),
  state: yup.string().required("State is required"),
  currency: yup.string().required("Currency is required"),
  amount: yup.string().required("Amount is required"),
});

export const step3Schema = yup.object({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  role: yup.string().required("Role is required"),
  phone: yup.string().required("Phone number is required"),
  countryCode: yup.string().optional(),
  lastUserCountry: yup.string().optional(),
});
